import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useReelAPI } from "../hooks/useAllCategoryData";
import { getFinalPricewithSymbol, getPriceSymbole } from "../Helper";
import RightPopUpSlider from "./RightPopUpSlider";
//import { Link } from "react-router-dom";

export default function Reels({ getAt, setActive }) {
  const { isLoading, error, data: reel } = useReelAPI();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [longVideo, setLongVideo] = useState();
  const [popup, setPopup] = useState(false);

  const closePopup = () => {
    setPopup(!popup);
  };

  const goToSlide = (i, long_video) => {
    setCurrentIndex(i);
    // console.log(i);
    setLongVideo("");
    setTimeout(() => {
      const tags = (
        <video muted autoPlay preLoad="auto" playsinline loop>
          <source src={long_video} type="video/mp4" />
        </video>
      );
      setLongVideo(tags);
      setPopup(true);
    }, 20);
    setTimeout(() => {     
      setPopup(true);
    }, 200);
  };

  const goToNextSlide = () => {
    const newIndex = (currentIndex + 1) % reel?.reels?.length;
    setCurrentIndex(newIndex);
    goToSlide(
      newIndex,
      process.env.REACT_APP_IMAGE_URL +
        "chaashni-long-video/" +
        reel?.reels?.[newIndex]["long_video"]
    );
  };

  const goToPrevSlide = () => {
    const newIndex = (currentIndex - 1 + reel?.reels?.length) % reel?.reels?.length;
    setCurrentIndex(newIndex);
    goToSlide(
      newIndex,
      process.env.REACT_APP_IMAGE_URL +
        "chaashni-long-video/" +
        reel?.reels?.[newIndex]["long_video"]
    );
  };

  if (error) return <div>{error.message}</div>;

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  //console.log("dd", reel);
  return (
    <>
      {!isLoading && (
        <div className="youtube-videos video-slider">
          <Carousel
            showDots={false}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            //autoPlay={this.props.deviceType !== "mobile" ? true : false}
            autoPlaySpeed={1000}
            //keyBoardControl={true}
            //customTransition="all .5"
            transitionDuration={500}
            containerclassName="carousel-container"
            //removeArrowOnDeviceType={["tablet", "mobile"]}
            //deviceType={this.props.deviceType}
            dotListclassName="custom-dot-list-style"
            itemclassName="carousel-item-padding-40-px"
          >
            {reel &&
              reel.reels.map((y, i) => (
                <div
                  key={i}
                  className="testi-item"
                  onClick={() =>
                    goToSlide(
                      i,
                      process.env.REACT_APP_IMAGE_URL +
                        "/chaashni-long-video/" +
                        y.long_video
                    )
                  }
                >
                  <div className="youtube-short" alt={y.name}>
                    <video
                      muted
                      autoPlay={"autoplay"}
                      preLoad="auto"
                      playsinline
                      loop
                    >
                      <source
                        src={`${process.env.REACT_APP_IMAGE_URL}/chaashni-short-video/${y.short_video}`}
                        type="video/mp4"
                      />
                    </video>
                  </div>
                  <div className="video-title">
                    <div className="video-thumb">
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}product/thumbnail/${y.thumbnail}`}
                        alt={y.thumbnail}
                      />
                    </div>
                    <div className="video-heading">
                      <span className="v-heading">{y.name}</span>
                      <span className="v-price">
                        {getPriceSymbole()}
                        {getFinalPricewithSymbol(
                          y.discount,
                          y.discount_type,
                          y.unit_price
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              ))}            
          </Carousel>
        </div>
      )}
      {isLoading && (
        <div className="loading-div">
          <span>Loading...</span>
        </div>
      )}
      {popup && (
        <div className={`popupvideo ${popup ? "active-pop" : ""}`}>
          <div className="popoverlay" onClick={() => closePopup()}>
            <span className="close-btn"></span>
          </div>

          <div className="popvideo-box">
            <div className="video-box">{longVideo}</div>
            <RightPopUpSlider currentIndex={currentIndex} reel={reel} />
          </div>
          <div onClick={goToPrevSlide} className="videoprev"></div>
          <div onClick={goToNextSlide} className="videonext"></div>
        </div>
      )}
    </>
  );
}
